import type { ReactNode } from 'react'
import { MetaTags } from '@/layouts/MetaTags'

/** 特設ページ（コラボ企画など）のレイアウト。サイトのナビ・フッターは出さず、ページが画面全体を使う */
export function CampaignLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <MetaTags />
      {children}
    </>
  )
}
